import React from 'react';
import {
  string, func, node, object,
} from 'prop-types';
import urlNormalizer from '../../helpers/urlNormalizer';

function WithNavigation({
  url,
  navigationClass,
  navigationStyle,
  renderChildren,
  children,
}) {
  if (url) {
    return (
      <a href={urlNormalizer.normalize(url)} style={navigationStyle} className={navigationClass}>
        {children}
      </a>
    );
  }

  return renderChildren ? renderChildren(children) : children;
}

WithNavigation.propTypes = {
  url: string,
  navigationClass: string,
  // eslint-disable-next-line react/forbid-prop-types
  navigationStyle: object,
  renderChildren: func,
  children: node.isRequired,
};

export default WithNavigation;
